import { HealthcheckBaseService } from '../gen/service/healthcheck-base-service'

export class HealthcheckService extends HealthcheckBaseService {}
